import { render, staticRenderFns } from "./ExpensesList.vue?vue&type=template&id=19ca1110&"
import script from "./ExpensesList.ts?vue&type=script&lang=js&"
export * from "./ExpensesList.ts?vue&type=script&lang=js&"
import style0 from "./ExpensesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports